<div class="col-md-7" style="float: left;">
  <nb-card>
    <nb-card-body>
      <div class="hundred-per-hor">
        <p-dropdown required class="limited-selector" id="inputVisita" placeholder="Visita"
          [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="visitas"
          [(ngModel)]="visitaSelected" (onChange)="changeVisita(visitaSelected)" [virtualScroll]="true"
          [itemSize]="31" [filter]="true" scrollHeight="120px">
        </p-dropdown>
      </div>
      <div class="hundred-per-hor">
        <p-dropdown [disabled]="deshabilitarOperador" required class="limited-selector" id="inputOperador" placeholder="Operador"
          [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="operadores"
          [(ngModel)]="operadorSelected" (onChange)="changeOperador(operadorSelected)" [virtualScroll]="true"
          [itemSize]="31" [filter]="true" scrollHeight="120px">
        </p-dropdown>
      </div>
      <div class="hundred-per-hor">
        <p-dropdown [disabled]="deshabilitarProceso" required class="limited-selector" id="inputProceso" placeholder="Proceso"
          [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="procesos"
          [(ngModel)]="procesoSelected" (onChange)="changeProceso(procesoSelected)" [virtualScroll]="true"
          [itemSize]="31" [filter]="true" scrollHeight="120px">
        </p-dropdown>
      </div>
      <div [hidden]="ocultarFechas" class="hundred-per-hor">
        <mat-form-field [hidden]="procesoModSelected == 2" class="fifty-per-hor" style="margin-right: 2%;">
          <mat-label>Fecha ETA</mat-label>
          <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaModETA" disabled (ngModelChange)="changeFechaModETA($event)" 
          [(ngModel)]="fechaModETA" name="fechaModETA">
          <mat-datepicker-toggle matSuffix [for]="pickerFechaModETA">
          </mat-datepicker-toggle>
          <mat-datepicker #pickerFechaModETA disabled="false"></mat-datepicker>
        </mat-form-field>
        <mat-form-field [hidden]="procesoModSelected == 2" class="fifty-per-hor">
          <mat-label>Fecha ATA</mat-label>
          <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaModATA" disabled (ngModelChange)="changeFechaModATA($event)" 
          [(ngModel)]="fechaModATA" name="fechaModATA">
          <mat-datepicker-toggle matSuffix [for]="pickerFechaModATA">
          </mat-datepicker-toggle>
          <mat-datepicker #pickerFechaModATA disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
      <div [hidden]="ocultarFechas" class="hundred-per-hor">
        <mat-form-field [hidden]="procesoModSelected == 1" class="fifty-per-hor" style="margin-right: 2%;">
          <mat-label>Fecha ETD</mat-label>
          <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaModETD" disabled (ngModelChange)="changeFechaModETD($event)" 
          [(ngModel)]="fechaModETD" name="fechaModETD">
          <mat-datepicker-toggle matSuffix [for]="pickerFechaModETD">
          </mat-datepicker-toggle>
          <mat-datepicker #pickerFechaModETD disabled="false"></mat-datepicker>
        </mat-form-field>
        <mat-form-field [hidden]="procesoModSelected == 1" class="fifty-per-hor">
          <mat-label>Fecha ATD</mat-label>
          <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaModATD" disabled (ngModelChange)="changeFechaModATD($event)" 
          [(ngModel)]="fechaModATD" name="fechaModATD">
          <mat-datepicker-toggle matSuffix [for]="pickerFechaModATD">
          </mat-datepicker-toggle>
          <mat-datepicker #pickerFechaModATD disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
      <nb-checkbox *ngIf="usersRol.ELIMINAR_VISITA" [disabled]="!habilitarGuardar" [(ngModel)]="eliminarSeleccionado">Eliminar</nb-checkbox>
     
           
          <!-- <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar
          </nb-checkbox> -->
        
      <div class="hundred-per-hor" style="text-align: -webkit-center;">
        <app-spinner *ngIf="showSpinnerUpload"></app-spinner>
        <label *ngIf="!showSpinnerUpload" class="file-upload" 
        type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
        (change)="addfile($event)">
          <input class="invi" type="file"/>
          <i class="fa fa-cloud-upload"></i> Subir Archivo
        </label>
        <p><strong>Archivo: </strong>{{fileName}}</p>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
      <button nbButton *ngIf="!showSpinnerGuardar"  [disabled]="!habilitarGuardar" size="large" status="primary" class="buttontz" style="width: 100%;" (click)="guardarModificacion()">Guardar</button>
    </nb-card-footer>
  </nb-card>
</div>
<div *ngIf="showGridModif" class="col-md-5" style="float: right;">
        <!-- <angular-slickgrid gridId="gridVinsModif"
            [columnDefinitions]="columnDefinitionsVinsModif"
            [gridOptions]="gridOptionsVinsModif" 
            [dataset]="dataVinsModif" 
            gridHeight="490"
            (onAngularGridCreated)="angularGridReadyVinsModif($event)">
          </angular-slickgrid> -->

            <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 490px;"
            [rowData]="dataVinsModif"
            [columnDefs]="columnDefinitionsVinsModif"
            (gridReady)="onGridReady($event)"
            [enableCellTextSelection]="true" />

</div>